import React from 'react';
import Navbar from '../components/Navbar';
import Banner from '../components/Banner';
import SchoolInfoSection from '../components/SchoolInfoSection';
import AboutUsSection from '../components/AboutUsSection';
import TeachingMethodology from '../components/TeachingMethodology';
import SchoolActivities from '../components/SchoolActivities';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
const HomePage = () => {
  return (
    <div className="overflow-x-hidden">
      <Navbar />
      <main>
        <Banner/>
        <SchoolInfoSection />
        <AboutUsSection />
        <TeachingMethodology />
        <SchoolActivities />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;